import {
  onCreateCategory,
  onDeleteCategory,
  onGetAllCategory,
  onGetCategoryDetail,
  onUpdateCategory,
} from "services/apis/category";
import snakeCaseKeys from "snakecase-keys";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doCreateCategory = createAsyncThunk(
  "category/doCreateCategory",
  async params => {
    const result = await onCreateCategory(params);
    if (!result) {
      return;
    }
    return result;
  }
);
export const doGetCategoryDetail = createAsyncThunk(
  "category/doGetCategoryDetail",
  async id => {
    const result = await onGetCategoryDetail(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateCategory = createAsyncThunk(
  "category/doUpdateCategory",
  async params => {
    const request = snakeCaseKeys(params);
    const id = params.id;
    const result = await onUpdateCategory(id, request);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteCategory = createAsyncThunk(
  "category/doDeleteCategory",
  async id => {
    const result = await onDeleteCategory(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetAllCategory = createAsyncThunk(
  "category/doGetAllCategory",
  async params => {
    const result = await onGetAllCategory(params);
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  categoryList: [],
};

const slice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [doCreateCategory.pending]: state => {
      state.isSaving = true;
    },
    [doCreateCategory.fulfilled]: state => {
      state.isSaving = false;
    },
    [doCreateCategory.rejected]: state => {
      state.isSaving = false;
    },
    [doGetAllCategory.pending]: state => {
      state.isSaving = true;
    },
    [doGetAllCategory.fulfilled]: state => {
      state.isSaving = false;
    },
    [doGetAllCategory.rejected]: state => {
      state.isSaving = false;
    },
  },
});

const { reducer } = slice;

export default reducer;

export const isSaving = createSelector(
  state => state.category.isSaving,
  isSaving => isSaving
);

export const getCategoryList = createSelector(
  state => state.category.categoryList,
  categoryList => categoryList
);
